import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconAppSmall(props: IconSmallProps) {
  return (
    <BaseIcon size={16} {...props} viewBox="0 0 16 16">
      <path
        d="M3 2C2.44772 2 2 2.44772 2 3V6C2 6.55229 2.44772 7 3 7H6C6.55229 7 7 6.55229 7 6V3C7 2.44772 6.55229 2 6 2H3ZM3 9C2.44772 9 2 9.44772 2 10V13C2 13.5523 2.44772 14 3 14H6C6.55229 14 7 13.5523 7 13V10C7 9.44772 6.55229 9 6 9H3ZM9 3C9 2.44772 9.44772 2 10 2H13C13.5523 2 14 2.44772 14 3V6C14 6.55229 13.5523 7 13 7H10C9.44772 7 9 6.55229 9 6V3ZM10 9C9.44772 9 9 9.44772 9 10V13C9 13.5523 9.44772 14 10 14H13C13.5523 14 14 13.5523 14 13V10C14 9.44772 13.5523 9 13 9H10Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
